export default __webpack_public_path__ + "static/media/Landslides and Avalanches f22f17947f1745caad34b43050e94d2d.fee7ef5b.md";